import clsx from 'clsx';
import type React from 'react';

type SkeletonType = 'avatar' | 'paragraph' | 'button';

interface SkeletonProps {
	type?: SkeletonType;
	width?: number | string;
	height?: number | string;
	lines?: number;
	className?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({
	type = 'paragraph',
	width,
	height,
	lines = 3,
	className,
}) => {
	const baseStyles = 'animate-pulse bg-grey-2 rounded';

	const getSkeletonStyles = () => {
		switch (type) {
			case 'avatar':
				return clsx(baseStyles, 'rounded-full w-15 h-15', className);
			case 'button':
				return clsx(baseStyles, 'rounded-full h-13 w-full', className);
			case 'paragraph':
				return 'space-y-2 w-full';
			default:
				return baseStyles;
		}
	};

	const getSkeletonDimensions = () => {
		const styles: React.CSSProperties = {};

		if (width) {
			styles.width = typeof width === 'number' ? `${width}px` : width;
		}

		if (height) {
			styles.height = typeof height === 'number' ? `${height}px` : height;
		}

		return styles;
	};

	if (type === 'paragraph') {
		return (
			<div className={getSkeletonStyles()}>
				{[...Array(lines)].map((_, index) => (
					<div
						key={index}
						className={clsx(baseStyles, 'h-4 w-full', className)}
					/>
				))}
			</div>
		);
	}

	return (
		<div className={getSkeletonStyles()} style={getSkeletonDimensions()} />
	);
};

export default Skeleton;
